import defaultFetchServiceOverride from "app/common/services/salesFetchService";
import createSignalsAlertsAPIService from "./factory";

const signalsAlertsAPIService = createSignalsAlertsAPIService(defaultFetchServiceOverride);

export default signalsAlertsAPIService;
